var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReceivableHead'),_c('div',{staticClass:"flex filter_table"},[_c('AllReceivablesTable',{staticClass:"w_100",attrs:{"filters":_vm.filters}}),_c('AllReceivablesFilter',{on:{"apply-filter":_vm.applyFilter}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }